import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ColumnHorizontal = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M17.5 15.8333C17.5 16.7538 16.764 17.5 15.8562 17.5L4.14383 17.5C3.23597 17.5 2.5 16.7538 2.5 15.8333L2.5 13.3333C2.5 12.4129 3.23597 11.6667 4.14384 11.6667L15.8562 11.6667C16.764 11.6667 17.5 12.4129 17.5 13.3333V15.8333Z"
          stroke={color}
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 4.16667C17.5 3.24619 16.764 2.5 15.8562 2.5L4.14384 2.5C3.23597 2.5 2.5 3.24619 2.5 4.16667L2.5 6.66667C2.5 7.58714 3.23597 8.33333 4.14384 8.33333H15.8562C16.764 8.33333 17.5 7.58714 17.5 6.66667V4.16667Z"
          stroke={color}
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default ColumnHorizontal
